import type { FC, ReactNode } from 'react'
import styled from '@emotion/styled'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import type { SignUpViewProps } from 'views/SignUp/SignUp'

import Testimonial from './Testimonial'
interface SeeHowYouCanProps {
  playbook: SignUpViewProps[`playbook`]
  testimonialLogo: ReactNode
}
const SeeHowYouCan: FC<SeeHowYouCanProps> = ({ playbook, testimonialLogo }) => {
  return (
    <MainSectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading>{playbook.heading}</CopyText.Heading>
          <CopyText.Description>{playbook.description}</CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <StyledSectionBase variant="2Col" reverse={true}>
          <Section.Copy>
            <CopyTextBase>
              <CopyText.Heading>{playbook.steps.title}</CopyText.Heading>
              <CopyText.Description>
                <FeatureWrapper>
                  {playbook.steps.items.map((step, idx) => (
                    <FeatureBoxBase alignment="left" key={`playbook-${idx}`}>
                      <FeatureBox.Body>
                        <FeatureBox.Title>{step.title}</FeatureBox.Title>
                        <FeatureBox.Text>{step.description}</FeatureBox.Text>
                      </FeatureBox.Body>
                    </FeatureBoxBase>
                  ))}
                </FeatureWrapper>
              </CopyText.Description>
              <CopyText.Link href={playbook.recipeLink}>Use this recipe</CopyText.Link>
            </CopyTextBase>
          </Section.Copy>
          <Section.Contents>
            <Testimonial data={playbook.testimonial} testimonialLogo={testimonialLogo} />
          </Section.Contents>
        </StyledSectionBase>
      </Section.Contents>
    </MainSectionBase>
  )
}

export default SeeHowYouCan

const MainSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`md`)} {
      padding-top: 120px;
    }
    ${({ theme }) => theme.breakpoints.down(`xs`)} {
      padding-top: 0;
    }
  }
`

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 0;
    padding-right: 0;
    padding-left: 0;
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-top: 120px;
    }
    ${({ theme }) => theme.breakpoints.up(`md`)} {
      padding-bottom: 80px;
    }
    ${({ theme }) => theme.breakpoints.down(`xs`)} {
      padding: 0;
    }
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      grid-template-areas: 'contents' 'copy';
    }
  }
`

const FeatureWrapper = styled.div`
  display: grid;
  gap: 24px;
  grid-template-rows: 1fr;
`
